(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reelup-reels"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.reelup-swiper', {
    slidesPerView: 1.2,
    spaceBetween: 16,
    loop: true,
    breakpoints: {
      0: {
        slidesPerView: 1.8
      },
      768: {
        slidesPerView: 3.5
      },
      1024: {
        slidesPerView: 4.5
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
